export enum UserSearchQueryEnum {
    Query = 'q'
}
